/*
 * @描述:axios的二次封装
 * @版本: 1.0
 * @作者: 冯强
 * @创建时间: 2022-11-23 17:36:27
 */
import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui'
import router from '../router'

const defaultAxios = axios.create({
    baseURL: '',
    timeout: 300000,
    withCredentials: false,
    headers: {'Content-Type': '  application/json;charset=UTF-8'},
})

defaultAxios.interceptors.request.use((config) => {
    //在请求头中携带token
    const vuex = JSON.parse(localStorage.getItem('vuex'))
    if (vuex && vuex.userInfo.ticket) {
        config.headers['lj-ticket'] = vuex.userInfo.ticket
    }

    if(vuex && vuex.userInfo && vuex.userInfo.appid && !config.headers.appid){
        config.headers['appid'] = vuex.userInfo.appid
    }
    return config
})

defaultAxios.interceptors.response.use((response) => {
    const {
        code,
        message,
        errcode,
        errmsg
    } = response.data
    console.log(response.data);
    //判断请求响应的code  9603 == 公司小程序不存在
    if (code === 200 || code === 9603 || errcode === 0) {
        //请求成功,返回请求体的data
        return response.data
    } else if (code === 10403) {
        //登录信息失效，token过期，给提示并跳转到登录页重新登录
        localStorage.removeItem('vuex')
        router.replace('/login')
        return Message.error(message + '，请重新登录')
    } else {
        //请求失败，给出提示
        Message({
            message: message ? message : errmsg,
            type: 'error',
            duration: 2000,
            onClose: () => { }
        })
    }
})

export const get = (url, params, config = {}) => {
    return new Promise((reslove, reject) => {
        let httpOption = {
            method: 'GET',
            url,
            params,
            ...config
        }
        defaultAxios(httpOption).then(response => {
            reslove(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const post = (url, data, config = {}) => {
    return new Promise((reslove, reject) => {
        if (config.form) {
            let headers = {}
            data = qs.stringify(data, {
                allowDots: true
            })
            config.headers = Object.assign(headers, config.headers)
        }
        let httpOption = {
            method: 'POST',
            url,
            data,
            ...config
        }
        defaultAxios(httpOption).then(response => {
            reslove(response)
        }).catch(error => {
            reject(error)
        })
    })
}
